module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Monitor.e0431ba9.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Monitor.svg
// module id = 1617
// module chunks = 0